import request, { requestRaw } from "utils/request";

import { baseRequestURL, constructQueryParams } from "api/BaseAPI";
import { toast } from "react-toastify";

export function createBlueprint(data, folderId, name) {
  return request(baseRequestURL + "v1/blueprints", {
    method: "POST",
    body: JSON.stringify({
      folder_id: folderId,
      wizard: data,
      suggested_fields: [],
      outcome: { behavior: "maximize" },
      name: name ? name : data.setup ? data.setup.label : ""
    })
  }).then((response) => response);
}

export function getBlueprints(folderId) {
  const queryArr = [];
  const queryURL = baseRequestURL + "v1/folders/" + folderId + "/blueprints" + constructQueryParams(queryArr);
  return request(queryURL, {
    method: "GET"
  }).then((response) => response);
}

export function getBlueprint(id) {
  return request(baseRequestURL + "v1/blueprint/" + id, {
    method: "GET"
  }).then((response) => response);
}

export function moveBlueprintFolder(id, folderId) {
  return request(baseRequestURL + "v1/blueprint/" + id, {
    method: "PATCH",
    body: JSON.stringify({
      folder_id: folderId
    })
  }).then((response) => response);
}

export function updateBlueprint(id, data, label) {
  const retData = {
    wizard: data
  };
  if (data?.setup || label) {
    retData.name = label || data.setup.label;
  }
  return request(baseRequestURL + "v1/blueprint/" + id, {
    method: "PATCH",
    body: JSON.stringify(retData)
  }).then((response) => response);
}

const updateBlueprintRawRequestOptions = {
  identicalEntityToast: () => {
    toast("No changes detected. Agent is already saved", {
      type: toast.TYPE.SUCCESS,
      position: toast.POSITION.TOP_CENTER,
      autoClose: 7500
    });
  }
};

export function updateBlueprintRawRequest(id, data, label, options = {}) {
  const opt = { ...updateBlueprintRawRequestOptions, ...options };

  const retData = {
    wizard: data
  };
  if (data?.setup || label) {
    retData.name = label || data.setup.label;
  }
  return requestRaw(baseRequestURL + "v1/blueprint/" + id, {
    method: "PATCH",
    body: JSON.stringify(retData)
  }).then(async (response) => {
    const body = await response.json();
    if (response.status === 400 && body?.[0]?.key === "ENTITY_IDENTICAL") {
      opt.identicalEntityToast();
      throw new Error("Blueprint was identical.");
    } else if (response.status >= 300) {
      const errorMessage = body?.[0]?.message ?? "Error handling this request";
      toast(errorMessage, {
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      });
      throw new Error(errorMessage);
    } else {
      return body;
    }
  });
}

export function handleDelete(id) {
  return request(baseRequestURL + "v1/blueprint/" + id, {
    method: "DELETE"
  }).then((response) => response);
}
